import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal, Spinner } from 'react-bootstrap';
import moment from 'moment';
import { FormikInput, FormikSelect, FormikDatePicker, BasicTextArea } from '../../../components';
import { debounceIndexEmployeesRequest } from '../../../requests/employees';
import { debounceIndexOtherRequestTypeRequest } from '../../../requests/otherRequestTypes';

const OtherRequestForm = ({
  onHide,
  submitVariant,
  errors,
  touched,
  action,
  setFieldValue,
  setFieldTouched,
  isSubmitting,
  rrhh,
  values,
  dispatch,
  reviewerSignature,
  employee
}) => {
  const [employees, setEmployees] = useState([]);
  const [otherRequestTypes, setOtherRequestTypes] = useState([]);


  const resultFetchEmployees = response => {
    const result = response.data.data;
    setEmployees(result.map(element => ({
      label: `${element.full_name} - ${element.national_identification}`,
      value: element.id
    })));
  };

  const fetchEmployees = () => {
    debounceIndexEmployeesRequest({
      dispatch,
      params: {
        actives: true,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        resultFetchEmployees(data);
      }
    });
  };


  useEffect(fetchEmployees, [])

  const resultFetchOtherRequestTypes = response => {
    const result = response.data.data;
    setOtherRequestTypes(result.map(element => ({
      label: element.name,
      value: element.id
    })));
  };

  const fetchOtherRequestTypes = () => {
    debounceIndexOtherRequestTypeRequest({
      dispatch,
      params: {
        is_active: true,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        resultFetchOtherRequestTypes(data);
      }
    });
  };
  useEffect(fetchOtherRequestTypes, [])

  const btnMessage = action === 'new' ? 'Crear' : 'Guardar';

  return (
    <Form>
      {isSubmitting && <Spinner animation="border" variant="primary" className="spinner-modal" />}
      <Modal.Body>
        {!employee ? (
          <Row>
            {rrhh && (
              <Col md={12}>
                <Field name="otherRequest[employeeId]">
                  {({ field }) => (
                    <FormikSelect
                      {...field}
                      label="Colaborador"
                      placeholder="Seleccionar Colaborador"
                      defaultValue={getIn(values, field.name)}
                      options={employees}
                      onChange={data => setFieldValue(field.name, data ? data.value : '')}
                      setFieldTouched={() => setFieldTouched(field.name)}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                      isClearable
                    />
                  )}
                </Field>
              </Col>
            )}
            <Col md={12}>
              <Field name="otherRequest[otherRequestTypeId]">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    label="Tipo de Solicitud"
                    placeholder="Seleccionar tipo de solicitud"
                    defaultValue={getIn(values, field.name)}
                    options={otherRequestTypes}
                    onChange={data => setFieldValue(field.name, data ? data.value : '')}
                    setFieldTouched={() => setFieldTouched(field.name)}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                    isClearable
                  />
                )}
              </Field>
            </Col>
            <Col md={6}>
              <Field name="otherRequest[startDate]">
                {({ field }) => (
                  <FormikDatePicker
                    {...field}
                    label="Fecha Desde"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={6}>
              <Field name="otherRequest[endDate]">
                {({ field }) => (
                  <FormikDatePicker
                    {...field}
                    label="Fecha Hasta"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={12}>
              <Field name="otherRequest[additional]">
                {({ field }) => (
                  <FormikInput
                    {...field}
                    label="Adicional"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={12}>
              <Field name="otherRequest[reason]">
                {({ field }) => (
                  <BasicTextArea
                    {...field}
                    inputType="textarea"
                    label="Motivo"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>

          </Row>
        ) : (
          <p>¿Estás seguro de querer {reviewerSignature ? 'firmar' : 'aprobar'} esta solicitud?</p>
        )}
        {reviewerSignature && (
          <Row>
            <Col md={12}>
              <Field name="otherRequest[signatureKey]">
                {({ field }) => (
                  <FormikInput
                    {...field}
                    label="Pin de firma"
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                    inputType="password"
                  />
                )}
              </Field>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn" type="submit" variant={submitVariant} disabled={isSubmitting} onClick={onHide}>
          {btnMessage}
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { otherRequest, reviewerSignature, signatureKey } = props;
  const { employeeId, otherRequestTypeId, startDate, endDate, additional, reason, rrhh, directApprove, id } = otherRequest;

  return {
    otherRequest: {
      id,
      employeeId,
      otherRequestTypeId,
      startDate,
      endDate,
      additional,
      reason,
      rrhh,
      directApprove,
      reviewerSignature,
      signatureKey
    }
  };
};

const validationSchema = Yup.object().shape({
  otherRequest: Yup.object().shape({
    employeeId: Yup.string().required('Debes seleccionar un trabajador'),
    otherRequestTypeId: Yup.string().required('Debes seleccionar un tipo de solicitud'),
    startDate: Yup.string().required('Debes ingresar una fecha desde'),
    endDate: Yup.string()
      .test('endDate', 'La fecha de término no puede ser menor a la fecha de inicio', function (value) {
        const startDate = moment(this.parent?.startDate, 'DD/MM/YYYY');
        if (!startDate || !value) return true;
        const endDate = moment(value, 'DD/MM/YYYY');
        return endDate.isAfter(startDate);
      }),
    additional: Yup.string().max(50, 'Máximo 50 caracteres'),
    reason: Yup.string().required('Debes ingresar un motivo').min(5, 'Mínimo 5 caracteres').max(500, 'Máximo 500 caracteres'),
    signatureKey: Yup.string().when('reviewerSignature', {
      is: val => val,
      then: Yup.string().required('Debes ingresar el pin'),
      otherwise: Yup.string().nullable()
    })
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: false,
  validateOnMount: props => props.action !== 'new'
})(connect()(OtherRequestForm));